// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ykm9G","label":"styles_label__GqByb"};